<div class="container">
  <div
    *ngFor="let value of valueOptions"
    class="option"
    [class.selected]="positionField.value === value"
    (click)="onChangePosition(value)"
  ></div>
</div>
